import styled from "styled-components";

export const Section = styled.div`
  background: ${(props) => props.color};
`;

export const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;

  @media (max-width: 769px) {
    padding: 30px 0px 50px 0px;
  }
`;

export const Button = styled.a`
  background-color: #951211;
  color: #ffffff;
  font-weight: 700;
  display: inline-block;
  margin: 30px 0px;
  padding: 12px 20px 10px 20px;
  border-radius: 7px;
  cursor: pointer;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4);
  text-decoration: none;
  &:hover {
    background-color: #bb1313;
  }
`;

export const Title = styled.h3`
  color: #951211;
  font-weight: 500;
  margin: 0px;
`;

export const TitleTwo = styled.h3`
  color: #951211;
  font-weight: 700;
  margin: 0px;
`;

export const TitleGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  justify-self: center;
  margin-bottom: 30px;
  width: 100%;
`;
